import { Button } from 'antd';
import { createContext, useState } from 'react';
import { STORAGE } from 'utils/enums/storage.enum';
import { THEME_MODE } from 'utils/enums/theme.enum';

export interface ThemeContextData {
  theme: ThemeMode;
  themeToggler(): void;
}

export const ThemeContext = createContext<ThemeContextData>({} as ThemeContextData);

export const ThemeButton = Button;

const ThemeProvider: React.FC = ({ children }) => {
  const [theme, setTheme] = useState<ThemeMode>(() => {
    const localTheme = localStorage.getItem(STORAGE.Theme_key);
    if (localTheme === THEME_MODE.dark) return THEME_MODE.dark;

    return THEME_MODE.light;
  });
  const setMode = (mode: ThemeMode) => {
    localStorage.setItem(STORAGE.Theme_key, mode);
    setTheme(mode);
  };

  const themeToggler = () => {
    setMode(theme === THEME_MODE.light ? THEME_MODE.dark : THEME_MODE.light);
  };
  return <ThemeContext.Provider value={{ theme, themeToggler }}>{children}</ThemeContext.Provider>;
};

export default ThemeProvider;
